
import { alertService } from './alert.service';
import { basePath } from './common.service';
import axios from 'axios';

// import { useTranslation } from 'react-i18next';

export interface dataObj {
    [key: string]: unknown;
}

export interface sendOptions {
    headers?: { [key: string]: string };
    timeout?: number;
}

interface errorResponse {
    message: string;
    status: number;
}

export interface submitObj{
    auth: boolean;
    token: string;
    ptype: string;
    url: string;
    queryparam: boolean;
    data: boolean;
}

export interface CommonResponse{
    status: boolean;
    extra: object | string;
    message: string;
    error: string;
    cursor: string;
    count: number;
}

//using backend paths
//object keys - ptype: call type, url: back path, queryparam: is using query params, data: is sending data object, auth: is must send authentication keys
export const submitCollection = {
    checkstat: <submitObj>{ ptype: "GET", url: basePath+"/service/system/Health", queryparam: false, data: false },
    signin: <submitObj>{ ptype: "POST", url: basePath+"/service/login/signIn", queryparam: false, data: true },
    getCompanyDetails: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/general/getCompanyDetails", queryparam: false, data: true },
    loadTermsAndConditions: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/general/loadTermsAndCondition", queryparam: false, data: true },
    loadAboutUs: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/general/loadAboutUs", queryparam: false, data: true },
    loadServerTime: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/general/loadServerTime", queryparam: false, data: true },

    loadMenu: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/menu/loadMenu", queryparam: false, data: true },
    loadCategoryList: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/menu/loadCategoryList", queryparam: false, data: true },
    loadBanners: <submitObj>{ ptype: "GET", url: basePath+"/service/v1/promo/loadBanners", queryparam: false, data: false },
    loadSingleDealDetails: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/deals/loadSingleDealDetails", queryparam: false, data: true },
    
    loadItemDetails: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/menu/loadItemDetails", queryparam: false, data: true },
    
    saveOrder: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/order/saveOrder", queryparam: false, data: true },
    removeLineItem: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/order/removeLineItem", queryparam: false, data: true },
    viewCartOrder: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/cart/loadCartOrder", queryparam: false, data: true },
    loadOrderItemDetails: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/order/loadOrderItemDetails", queryparam: false, data: true },
    loadOrders: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/order/loadOrders", queryparam: false, data: true },
    loadOrderFulfillmentDetails: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/order/loadOrderFulfillmentDetails", queryparam: false, data: true },
    loadSingleOrder: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/order/loadSingleOrder", queryparam: false, data: true },
    loadCartItemCount: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/cart/loadCartItemCount", queryparam: false, data: true },
    
    processPayment: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/order/payment", queryparam: false, data: true },
    checkOrderItemsAvailability: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/order/loadOrderItemAvailability", queryparam: false, data: true },
    saveOrderReview: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/order/saveOrderReview", queryparam: false, data: true },
    loadOrderReviewMasterData: <submitObj>{ ptype: "GET", url: basePath+"/service/v1/order/loadReviewMasterData", queryparam: true, data: false },
    loadAvailablePaymentOptions: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/order/loadAvailablePaymentOptions", queryparam: false, data: true },
    applyPromotion: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/promo/applyPromotion", queryparam: false, data: true },
    removeDiscount: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/promo/removeDiscount", queryparam: false, data: true },
    getDeliveryDetails: <submitObj>{ ptype: "POST", url: basePath+"/service/v1/order/getDeliveryDetails", queryparam: false, data: true },
    
}

/**
* this is the main backcalls handler, every backcall in application goes through here
*
* @param {*} callstat submitcollection object for single call
* @param {*} cobj saving object 
* @param {*} showalerts is needed to show alert when found errors
* @param {*} options additional options for axios call
* @return {*} 
*/
export async function submitSets (callstat: submitObj = {
    auth: false,
    token: "",
    ptype: "POST",
    url: "",
    queryparam: false,
    data: false
}, cobj: unknown, showalerts = true, options: sendOptions | null, showbackerrors = true) {
    // const { t } = useTranslation();

    const csubObj: submitObj = callstat;
 
    //set custom headers
    const checknewheaders = (options && options.headers ? options.headers : {});
    const coheaders = { ...checknewheaders, 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' };

    if(csubObj !== undefined && Object.keys(csubObj).length > 0){
        try {
            const res = await axios({
                method: csubObj.ptype,
                url: csubObj.url + (csubObj.queryparam && cobj ? cobj : ""),
                data: (csubObj.data && cobj ? cobj : ""),
                headers: coheaders
            });

            if(res.status === 200){  
                if(res.data !== undefined){
                    if(res.data.status){
                        return res.data;
                    } else{
                        if(showbackerrors){
                            errorHandler(res.data, false);
                        }
                        return res.data;
                    }
                } else{
                    return false;
                }
            }
        } catch (error) {
            errorHandler(error as errorResponse, showalerts);
            return false;
        }
    } else{
        if(showalerts){
            alertService.error("Invalid call parameters");
        }
        return false;
    }
 }

//error handle in backend calls
export function errorHandler(err: errorResponse, showalerts: boolean = true) {
    // const { t } = useTranslation();

    if (err !== undefined) {

        const creserr = JSON.parse(JSON.stringify(err));
        //console.log(creserr);
        if(creserr&&creserr.message&&creserr.message.indexOf("401") > -1){
            alertService.error("AUTH_FAILED");
            //redirect to signin
        }
        if (showalerts || (creserr&&creserr.message&&creserr.message.indexOf("Network Error") > -1)) {
            alertService.error(err.message);
        }

    } else {
        if (showalerts) {
            alertService.error("UNRECOGNIZED_ERROR");
        }
    }
}